import { BooleanOperators, IColumnFilterComparison } from '../reportFilters';

import { FilterableColumnTypes } from './accountSummaryColumns';

export type ISingleValueColumnFilter<ColumnType extends FilterableColumnTypes> = IColumnFilterComparison & ColumnType;

export interface ICompositeColumnFilter<ColumnType extends FilterableColumnTypes> {
  operator: BooleanOperators;
  value: ISingleValueColumnFilter<ColumnType>[];
}

export type IColumnFilterMDS<ColumnType extends FilterableColumnTypes> =
  | ISingleValueColumnFilter<ColumnType>
  | ICompositeColumnFilter<ColumnType>;

export const ColumnFilterMDS = <ColumnType extends FilterableColumnTypes>(columnType: ColumnType) => columnType;

export const isSingleValueColumnFilter = <ColumnType extends FilterableColumnTypes>(
  valueColumnFilter: IColumnFilterMDS<ColumnType>
): valueColumnFilter is ISingleValueColumnFilter<ColumnType> => {
  switch (valueColumnFilter.operator) {
    case BooleanOperators.And:
    case BooleanOperators.Or:
      return false;
    default:
      return true;
  }
};
